<template>
  <LabelBadge
    :label="CONFIG[result].label"
    :color="CONFIG[result].color"
    :icon="CONFIG[result].icon"
    :size="size"
    :data-testid="`eligibility-chip-${result}`"
  />
</template>

<script setup lang="ts">
import { mdiCheckCircleOutline, mdiClockOutline, mdiLockOutline } from '@mdi/js'

import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import type {
  LabelBadgeColor,
  LabelBadgeSize
} from '@/components/designSystem/Badges/LabelBadge.vue'
import { EligibilityResult } from '@/types/qualification-eligibility.types'

withDefaults(defineProps<{ result: EligibilityResult; size?: LabelBadgeSize }>(), {
  size: 'small'
})

/** Resultado da pré-checagem (A8) → chip ao lado do médico. */
const CONFIG: Record<EligibilityResult, { label: string; color: LabelBadgeColor; icon: string }> = {
  [EligibilityResult.ELIGIBLE]: { label: 'Atende', color: 'green', icon: mdiCheckCircleOutline },
  [EligibilityResult.PRE_ALLOCATABLE]: {
    label: 'Pré-alocável',
    color: 'orange',
    icon: mdiClockOutline
  },
  [EligibilityResult.NOT_ELIGIBLE]: { label: 'Não atende', color: 'red', icon: mdiLockOutline }
}
</script>
